import React, {useState, useMemo, useEffect} from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
  import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
  import { ModuleRegistry } from "@ag-grid-community/core";
  import { useNavigate } from "react-router-dom";
  import axios from "axios";
  import { apiUrl } from "../../../config/Config";

  import {
    faPlus,
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { useSelector, useDispatch } from "react-redux";
  import Editor from "../../common/Editor";

  ModuleRegistry.registerModules([ClientSideRowModelModule]);

const AddEvent = () => {
  const userdata = useSelector((store) => store.userReducer.userdata);
  const dispatch = useDispatch();
    const [forceupdate, setforceupdate] = useState(false);
    const [editorLoaded, setEditorLoaded] = useState(true);

    const [sdesc, setsdesc] = useState("");
    const [bimage, setbimage] = useState(null);
    const [bdesc, setbdesc] = useState("");

    const [title, settitle] = useState("");
    const [subhead, setsubhead] = useState("");
    const [date, setdate] = useState("");
    const [time, settime] = useState("");
    const [state, setstate] = useState("");
    const [city, setcity] = useState("");
    const [address, setaddress] = useState("");
    const [tumbnailimage, settumbnailimage] = useState("");

    const navigate = useNavigate();

    const handlesubmitcoupon = async(statusnum) => {
      if(title && date && time && city) {
        var data = {
          title: title,
          subtitle: subhead,
          date: date,
          time: time,
          state: state,
          city: city,
          address: address,
          image: tumbnailimage
        }
        console.log('data >>', data);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "addnewevent",data, headers)
          .then((res) => {
            // console.log('res >>', res.data)
            // category data
            if (res?.data?.status == "success") {
              navigate('/admin/events')
            } else {
              if (res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} });
                navigate("/admin/login");
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            console.log("err >>", err);
          });
  
        
      }
      
      // 
    }

    const getBase64 = (file) => {
      return new Promise((resolve) => {
        let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();
  
        // Convert the file to base64 text
        reader.readAsDataURL(file);
  
        // on reader load somthing...
        reader.onload = () => {
          // Make a fileInfo Object
          // console.log("Called", reader);
          baseURL = reader.result;
          // console.log(baseURL);
          resolve(baseURL);
        };
        // console.log(fileInfo);
      });
    };

    const handleinputchange = async (file) => {
      var obj = {};
      await getBase64(file).then((result) => {
        obj["name"] = file.name;
        obj["image"] = result;
      });
      // console.log('obj >>', obj);
      settumbnailimage(obj);
    };

    return (
      <div className="">
        <div className="dashboardbox" style={{ width: "100%" }}>
          <div className="inventorysave-row addproduct-save-row">
            <p className="inventorysummary-text addproduct-text">
              Create New Event
            </p>
            <div className="inventory-save-btn add-product-btn" style={{marginLeft: 'auto'}} onClick={() => {handlesubmitcoupon(1)}}>
              <p>Save & Publish</p>
            </div>
          </div>
          <div className="inventorysummaryrow row mt-3">
            <div className="col-md-5">
              <div className="">
                <label className="addproduct-label">Title *</label>
                <input
                value={title}
                onChange={(t) => {settitle(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Enter Title of Event"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Date *</label>
                <input
                type="Date"
                value={date}
                onChange={(t) => {setdate(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Select Date"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">State *</label>
                <input
                type="text"
                value={state}
                onChange={(t) => {setstate(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Enter State of Event"
                />
              </div>
              <div className="mt-3">
              <label className="addproduct-label">Complete Address</label>
                <textarea
                value={address}
                onChange={(t) => {setaddress(t.target.value)}}
                  className="form-control addproductinput"
                  style={{ height: 80 }}
                  placeholder="Enter Address"
                ></textarea>
              </div>
              
            </div>
            <div className="col-md-5">
            <div className="">
                <label className="addproduct-label">Subhead</label>
                <input
                value={subhead}
                onChange={(t) => {setsubhead(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Enter Subtext of Event"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Time *</label>
                <input
                value={time}
                type="time"
                onChange={(t) => {settime(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Enter Time"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">City</label>
                <input
                value={city}
                type="text"
                onChange={(t) => {setcity(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Enter City of Event"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Thumbnail Image</label>
                <input
                  onChange={(t) => {
                    handleinputchange(t.target.files[0]);
                  }}
                    accept="image/*"
                    type="file"
                  className="form-control addproductinput"
                  placeholder="Enter City of Event"
                />
              </div>
            {/* <div className="">
              <label className="addproduct-label">Article Details</label>
              <div className="descriptionckeditor" style={{ marginTop: 7 }}>
                <Editor
                  name="name"
                  value={bdesc}
                  onChange={(data) => {
                    setbdesc(data);
                  }}
                  editorLoaded={editorLoaded}
                  className="addproductinput"
                />
              </div>
            </div> */}
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
    );
}

export default AddEvent;